// The curves are laid out in a square user space and stretched to the
// container, so a beam keeps its shape whatever the aspect ratio.
export const BEAMS_VIEWBOX_SIZE = 100;

// How far a beam drifts sideways between the bottom and the top
const BEAM_DRIFT = 48;

// Beams start below and end above the viewbox, so no end is ever visible
const BEAM_START_Y = 112;
const BEAM_END_Y = -12;

const BEAM_FIELD_MARGIN = 60;

const SPEED_MIN = 0.6;
const SPEED_RANGE = 0.9;

const DRIFT_JITTER = 8;

export type Beam = {
  d: string;
  durationMs: number;
  delayMs: number;
};

// Stable pseudo-random: the same beams come back on every render, so a
// re-render never reshuffles the background.
function noise(seed: number): number {
  const value = Math.sin(seed * 12.9898) * 43758.5453;

  return value - Math.floor(value);
}

export function buildBeams(count: number, durationMs: number): Beam[] {
  const field = BEAMS_VIEWBOX_SIZE + BEAM_FIELD_MARGIN * 2;
  const spread = field / Math.max(count - 1, 1);

  return Array.from({ length: count }, (_, index) => {
    const x = -BEAM_FIELD_MARGIN + index * spread;
    const drift =
      BEAM_DRIFT + noise(index + 1) * DRIFT_JITTER - DRIFT_JITTER / 2;
    const beamDuration =
      durationMs * (SPEED_MIN + noise(index + 7) * SPEED_RANGE);

    return {
      d: `M${x} ${BEAM_START_Y} C${x + 22} 74, ${x + 14} 42, ${x + drift} ${BEAM_END_Y}`,
      durationMs: beamDuration,
      // Spread over a full trip so the beams never travel in formation
      delayMs: noise(index + 13) * beamDuration,
    };
  });
}
